import React from 'react';
import './PoweredByBanner.css';

const PoweredByBanner = () => {
  return (
    <footer className="powered-by-banner">
      <div className="mag-container">
        <p>
          <a 
            href="https://christofercodes.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="powered-by-link"
          >
            <span className="original-text">Design & Utveckling av</span>
            <span className="hover-text">www.christofercodes.com</span>
          </a>
        </p>
      </div>
    </footer>
  );
};

export default PoweredByBanner;